import { Component, OnInit, Input, Output, EventEmitter, IterableDiffers, TemplateRef, ViewChild, KeyValueDiffers, ElementRef } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';

import { Collection } from '../model/collection/collection';
import { InterfaceElementTypes } from '../model/interfaceElement/interfaceElement-properties/interfaceElement-type';
import { InterfaceElement, IEValue } from '../model/asd/asd-properties/asd-ie/asd-interfaceElement';
import { DownloadFile } from '../model/asd/asd-properties/asd-downloadFile';
import { FormInterfaceCommunicatorProperty } from '../model/form/form-properties/form-interfaceCommunicatorProperty';
import { CosyAppStateDataControllerService } from '../service/controller/cosy-app-state-data-controller.service';
import { CosyCommunicationControllerService } from '../service/controller/cosy-communication-controller.service';
import { CosyFormGroupValidationService } from '../service/validator/cosy-form-group-validation.service';
import { CollectionSearchComponent } from '../cosy-collection/collection-search.component';
import { UXControllerService } from '../service/controller/ux-controller.service';
import { Subscription } from 'rxjs';
import { Attribute } from '../model/asd/asd-properties/asd-attribute';
import { Message } from '../model/asd/asd-properties/asd-message';
import { UserActions } from '../model/useraction/useractions';
import { CollectionCreatetreeComponent } from '../cosy-collection/collection-createtree.component';
import { FormBase } from '../model/form/form';
import { FormState } from '../model/form/form-properties/form-state';

@Component({
  selector: 'app-cosy-form-control',
  templateUrl: './cosy-form-control.component.html',
  styleUrls: ['./cosy-form-control.component.css']
})
export class CosyFormControlComponent implements OnInit {
  constructor(
    public uxControllerService: UXControllerService,
    private cosyAppStateDataControllerService: CosyAppStateDataControllerService,
    private cosyFormGroupValidationService: CosyFormGroupValidationService,
    private cosyCommunicationControllerService: CosyCommunicationControllerService,
    private modalService: BsModalService
  ) {
    this.subscriptionUXUA = this.uxControllerService.executeDCUC.subscribe(
      (dutyComplete: boolean) => this.executeDutyComplete(dutyComplete)
    );
  }
  @Input() ie:InterfaceElement;
  @Input() sessionID: string;
  @Input() ieCompleteList: InterfaceElement[] = [];
  @Input() downloadFile: DownloadFile;
  @Input() cosyFormInit : FormBase;
  @Input() isFromRibbon : FormBase;
  @ViewChild(CollectionSearchComponent) collectionSearch:CollectionSearchComponent;
  @ViewChild(CollectionCreatetreeComponent) newCollectionTree:CollectionCreatetreeComponent;
  
  private IE_TYPES = InterfaceElementTypes;
  private subscriptionUXUA:Subscription;
  private formState: string = '';
  private currentUserActionID: string = '';
  private uxControllerIndex: number = -1;
  private wizardIndex: number = -1;
  private clickedUAIEID: string = '';

  private dutyComplete: boolean;
  public showMessageBar: boolean = false;
  private isUXUAIDcalled = false;

  private formMessageOptions = [];
  private icProps: FormInterfaceCommunicatorProperty;
  private collection: Collection;
  //public collectionTyp: string;
  public formgroup:FormGroup = null;
  public fcViews: InterfaceElement [] = [];
  private ieList: InterfaceElement[] = [];
  public fcAddStyle: string = '';

  modalRef: BsModalRef;


  ngOnInit() {   
    
    this.fcViews = this.ie.InterfaceElements;
    this.wizardIndex = this.ieCompleteList.map(function(e){return e.TypeDID}).indexOf(InterfaceElementTypes.Wizard);
   
    if(this.uxControllerService.ieEntity!= null){
      this.ieList.push(this.uxControllerService.ieEntity);
    }
   
    this.updateFormControls(this.ie.InterfaceElements, this.cosyFormInit);
    
    if (this.ie.InterfaceElementGroup == null) {
      this.ie.InterfaceElementGroup = this.cosyFormGroupValidationService.toFormGroup(this.ie);
    }
    this.formgroup = this.ie.InterfaceElementGroup;
  
    if(this.wizardIndex > -1) {
      let groupIndex = this.ieCompleteList[this.wizardIndex].InterfaceElements.map(function(e){return e.TypeDID}).indexOf(InterfaceElementTypes.Groups);
      for(let tie of this.ieCompleteList[this.wizardIndex].InterfaceElements[groupIndex].InterfaceElements){
        if(tie.Attributes.Active){
          this.dutyComplete = this.uxControllerService.onEditDutyTest(tie.InterfaceElementGroup, 'init');
        }
      }
    }
    
    //if (this.uxControllerService.ieSearch != null && this.uxControllerService.ieSearch.CustomizeOptions != null && this.uxControllerService.ieSearch.CustomizeOptions.Properties != null && this.uxControllerService.ieSearch.CustomizeOptions.Properties.TypeFilterCol != null) this.collectionTyp = this.uxControllerService.ieSearch.CustomizeOptions.Properties.TypeFilterCol;
  }

  ngOnDestroy() {
    this.subscriptionUXUA.unsubscribe();
  }

  openModal(template: TemplateRef<any>, messageOptions) {
    if (messageOptions > 0) {
      this.modalRef = this.modalService.show(template);
    }
  }

  showFormMessage() {
    if (this.icProps != null && this.icProps.message.messageText.length > 0 && this.icProps.options.length <= 0) {
      this.showMessageBar = true;
    } else {
      this.showMessageBar = false;
    }
  }

  formStatePerUserAction(
    userActionID: string,
    uaInterfaceElementID: string,
    interfaceCommunicatorProps: FormInterfaceCommunicatorProperty,
    callFromMessage: boolean,
    optionID: string,
    processOnServer: boolean) {
  
    if (userActionID != null) {
      this.clickedUAIEID = uaInterfaceElementID;
      this.icProps = this.uxControllerService.processUXUserAction(userActionID, this.uxControllerService.cosyFormInitProperties.UXControllerProperties, interfaceCommunicatorProps, callFromMessage, optionID, processOnServer, this.ie.InterfaceElementID);
      this.uxControllerService.cosyFormInitProperties.UXControllerProperties.FormCurrentState = this.icProps.TransitStateID;
      this.uxControllerService.cosyFormInitProperties.UXControllerProperties.FormCurrentUserActionID = userActionID;
      this.icProps.UXControlInterfaceElementID = this.ie.InterfaceElementID;
      this.currentUserActionID = this.icProps.userActionID;
      this.updateFormControls(this.ie.InterfaceElements,this.uxControllerService.cosyFormInitProperties.UXControllerProperties)
    
      this.formMessageOptions = this.icProps.options;
      this.showFormMessage();
      this.icProps.ClickedUAInterfaceElementID = this.clickedUAIEID;
      this.formState = this.uxControllerService.cosyFormInitProperties.UXControllerProperties.FormCurrentState;

      if (this.icProps.ProcessRequiredOnServer) {
        this.isUXUAIDcalled = true;
        this.uxControllerService.isAPOS = true;
        this.uxControllerService.fetchUXUserAction(this.icProps.userActionID, this.icProps.ClickedUAInterfaceElementID, this.icProps.OldStateID);
      } else {
        if(this.ieList.length> 0){
          this.ieList = this.cosyAppStateDataControllerService.updateUIObjectsOfIE(this.ieList, this.uxControllerService.cosyFormInitProperties.UXControllerProperties, false, null);
          this.uxControllerService.ieEntity = this.ieList[0];
          this.isUXUAIDcalled = false;
          this.uxControllerService.isAPOS = false;
        }
      }

      this.formState = this.uxControllerService.cosyFormInitProperties.UXControllerProperties.FormCurrentState;
    
      // CollectionController from UX
      if (userActionID == UserActions.AddColumnUA){ //ColAdd
        this.collectionSearch.openCollectionSearch();
      }
      else if (userActionID == UserActions.RemoveColumnUA){ //ColRemove
        this.removeFromCollection();
      }
      else if (userActionID == UserActions.NewTreeCollectionUA){ //newTreeCollection
        this.newCollectionTree.openNewCollTree();
      }
      else if (UserActions.TreeDuxUA.indexOf(userActionID) != -1) this.uxControllerService.fetchTreeUserAction(userActionID, null);
    }
  }

 updateFormControls(ieList: InterfaceElement[], uxControllerProps: FormBase){
  let formState: FormState = null;
  this.fcViews = [];
  
  if (uxControllerProps != null) {
    formState = this.cosyAppStateDataControllerService.getFormState(uxControllerProps);
  }

  for (let control of ieList) {  
      if (control.TypeDID == InterfaceElementTypes.Trigger) {
        for (let status of formState.actions) {
          if ((status.fCID == control.InterfaceElementID || 
               status.fCID == control.TemplateID) && 
               (status.attributes.visible && 
                ((control.Attributes.Active == null && control.Attributes.Visible) || 
                (control.Attributes.Active != null && control.Attributes.Active && 
                  control.Attributes.Visible)))) {
                  control.Attributes.Enabled = status.attributes.enabled;
                    this.fcViews.push(control);
              }
           }
      } else if (control.TypeDID === InterfaceElementTypes.InputPicklist) {
           this.fcViews.push(control);
      }
      else if (control.TypeDID === InterfaceElementTypes.ListSubUXController) { // SubUXController zur Zeit nur LV
       
        for (let control_sub of control.InterfaceElements) {
        
          if (control_sub.TypeDID == InterfaceElementTypes.Trigger && control_sub.Attributes.Visible) {
            for (let status of formState.actions) {  // Abfrage von control.InterfaceElementID da HauptFC nur GruppierungsInterfaceElement steuert                 
              /*if ((status.fCID == control.InterfaceElementID || 
                   status.fCID == control.TemplateID) && 
                   (status.attributes.visible && 
                    ((control.Attributes.Active == null && control.Attributes.Visible) || 
                    (control.Attributes.Active != null && control.Attributes.Active 
                      && control.Attributes.Visible)))) {
                control_sub.Attributes.Enabled = status.attributes.enabled; 
                this.fcViews.push(control_sub);
              }*/
              if ((status.fCID == control.InterfaceElementID || 
                status.fCID == control.TemplateID) && 
                (status.attributes.visible && 
                 ((control_sub.Attributes.Active == null && control_sub.Attributes.Visible) || 
                 (control_sub.Attributes.Active != null && control_sub.Attributes.Active 
                   && control_sub.Attributes.Visible)))) {
                      control_sub.Attributes.Enabled = status.attributes.enabled; 
                      this.fcViews.push(control_sub);
                   }
            }
          } else if (control_sub.TypeDID === InterfaceElementTypes.InputPicklist) {
            this.fcViews.push(control_sub);
          }
        }
      }
    }
    this.fcViews.sort((a,b) => a.Attributes.DisplayOrder - b.Attributes.DisplayOrder);
  }

  executeDutyComplete(dutyComplete:boolean) {
    if (dutyComplete) {
      this.formStatePerUserAction(this.uxControllerService.cosyFormInitProperties.UXControllerProperties.FormValidUAID, this.clickedUAIEID, this.icProps, false, null, null);
    } else if (!dutyComplete) {
      this.formStatePerUserAction(this.uxControllerService.cosyFormInitProperties.UXControllerProperties.FormInvalidUAID, this.clickedUAIEID, this.icProps, false, null, null);
    }
  }

  chkdutyComplete() {
    this.dutyComplete = this.uxControllerService.onEditDutyTest(this.formgroup, this.currentUserActionID);
    if (this.dutyComplete) {
      this.formStatePerUserAction(this.uxControllerService.cosyFormInitProperties.UXControllerProperties.FormValidUAID, this.clickedUAIEID, this.icProps, false, null, null);
    } else if (!this.dutyComplete) {
      this.formStatePerUserAction(this.uxControllerService.cosyFormInitProperties.UXControllerProperties.FormInvalidUAID, this.clickedUAIEID, this.icProps, false, null, null);
    }
  }

  addToCollection(collection: Collection){
    this.collection = collection;
    this.collection.entityID = this.ie.ObjectID;
    this.addRemoveCollection(this.collection);
  }

  removeFromCollection(){
    this.collection = new Collection();
    this.collection.collectionID = null;
    this.cosyCommunicationControllerService.searchOption.forEach(element => {
      if (element.type == 'Collections') this.collection.collectionID = element.ID;
    });
    this.collection.entityID = this.ie.ObjectID;
    this.collection.action = 'remove';
    this.addRemoveCollection(this.collection);
  }

  addRemoveCollection(collection:Collection) {
    let newMessage = new Message();
    newMessage.buttonOkText = 'Ok';
    newMessage.messageType = 0;
    newMessage.environment = 'lokal';
    if (collection.collectionID == null || collection.collectionID == '') newMessage.showText = 'Bitte wählen Sie eine Warengruppe aus.';
    //else if (this.selectedRowID == null || this.selectedRowID.length == 0) newMessage.showText = 'Auswahl?';
    else if (this.uxControllerService.ieEntityList == null || this.uxControllerService.ieEntityList.Values.length == 0) newMessage.showText = 'Bitte wählen Sie einen Eintrag aus.';
    if (collection.action == 'add' && newMessage.showText == null) {
        this.cosyCommunicationControllerService.addToCollection(this.sessionID, collection.collectionID, collection.entityID, this.uxControllerService.activeSelectedRowID, this.uxControllerService.activeSelectedRowDisplayName).subscribe(
          sucess => {console.log('Sucess: ', sucess);},
          error => {console.error('ERROR: ', error); newMessage.showText = error; this.uxControllerService.showMessage.next(newMessage);},
        )
    }
    else if (collection.action == 'remove' && newMessage.showText == null) {
      this.cosyCommunicationControllerService.removeFromCollection(this.sessionID, collection.collectionID, this.uxControllerService.activeSelectedRowID).subscribe(
        sucess => {console.log('Sucess: ', sucess)
        if (this.cosyCommunicationControllerService.searchOption.length > 0) 
        {
          let additionalIEs: InterfaceElement[] = [];
          let attribute: Attribute = new Attribute();
          let ielist: InterfaceElement = new InterfaceElement();
          attribute.ActivePage = 1;
          ielist.InterfaceElementID = this.uxControllerService.ieEntityList.InterfaceElementID;
          ielist.Values = this.uxControllerService.ieEntityList.Values;
          ielist.Attributes = attribute;
          additionalIEs.push(ielist);
          let searchText:string = '';
          this.cosyCommunicationControllerService.searchOption.forEach(element => searchText += element.searchString);
          this.uxControllerService.fetchIEUserAction(
             this.uxControllerService.ieSearch.Attributes.OnSelectUAID,
             this.uxControllerService.ieSearch,
             searchText,
             null,
             null,
             additionalIEs,
             null,
             null
           )
        }
      
      },
      error => {console.error('ERROR: ', error); newMessage.showText = error; this.uxControllerService.showMessage.next(newMessage)},
      )
    }
    else this.uxControllerService.showMessage.next(newMessage);
  }

  ngDoCheck(){
    if(this.uxControllerService.isDynaFunctionCompleted && this.uxControllerService.dynaReferenceIEID == this.ie.InterfaceElementID){
      this.updateFormControls(this.ie.InterfaceElements, this.cosyFormInit);
      this.uxControllerService.isDynaFunctionCompleted = false;
    }
  }
}
